module.exports = __webpack_public_path__ + "static/media/Private_preschool1.b900a456.jpg";